export default __webpack_public_path__ + "static/media/cameraStand.02ba720f.png";